
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-preventions',
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      resetMap: null,
      updateMap: null,
      switchCodeOrMap: false,
      location: {
        cp: null,
        lat: null,
        lng: null,
        city: null,
        state: null,
        street: null,
        reference: null,
        neighborhood: null,
        outdoorNumber: null,
        interiorNumber: null,
      },
      rules: [(v) => !!v || this.$t('fieldRequired')],
    }
  },
  computed: {
    ...mapGetters({
      platformLatLng: 'setting/platformLatLng' || [
        16.49847115994006, -76.22896135,
      ],
    }),
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    labelField() {
      if (this.obj && this.obj.schema) {
        return this.obj.schema.label || this.obj.schema.name
      }
      return ''
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.location = val
          ? {
              cp: val.cpPrevention,
              lat: val.latPrevention,
              lng: val.lngPrevention,
              city: val.cityPrevention,
              state: val.statePrevention,
              street: val.streetPrevention,
              reference: val.referencePrevention,
              neighborhood: val.neighborhoodPrevention,
              outdoorNumber: val.outdoorNumberPrevention,
              interiorNumber: val.interiorNumberPrevention,
            }
          : {
              cp: null,
              lat: Number(this.platformLatLng[0]),
              lng: Number(this.platformLatLng[1]),
              city: null,
              state: null,
              street: null,
              reference: null,
              neighborhood: null,
              outdoorNumber: null,
              interiorNumber: null,
            }
      }
    },
  },
  mounted() {
    this.switchCodeOrMap = this.value?.switchCodeOrMap || false
    this.resetMap = this.value?.resetMap || null
    this.location = this.value
      ? {
          cp: this.value.cpPrevention,
          lat: this.value.latPrevention,
          lng: this.value.lngPrevention,
          city: this.value.cityPrevention,
          state: this.value.statePrevention,
          street: this.value.streetPrevention,
          reference: this.value.referencePrevention,
          neighborhood: this.value.neighborhoodPrevention,
          outdoorNumber: this.value.outdoorNumberPrevention,
          interiorNumber: this.value.interiorNumberPrevention,
        }
      : {
          cp: null,
          lat: this.platformLatLng[0],
          lng: this.platformLatLng[1],
          city: null,
          state: null,
          street: null,
          reference: null,
          neighborhood: null,
          outdoorNumber: null,
          interiorNumber: null,
        }
  },
  methods: {
    save(location) {
      this.$emit('input', location)
    },
    handlerLocation(event) {
      if (event) {
        this.location = Object.assign({}, event)
        // The keys in db will be with 'Prevention'
        const location = {
          cpPrevention: event.cp,
          latPrevention: event.lat,
          lngPrevention: event.lng,
          cityPrevention: event.city,
          statePrevention: event.state,
          streetPrevention: event.street,
          referencePrevention: event.reference,
          neighborhoodPrevention: event.neighborhood,
          outdoorNumberPrevention: event.outdoorNumber,
          interiorNumberPrevention: event.interiorNumber,
        }
        this.save(location)
      } else {
        this.save(null)
      }
    },
  },
}
